import type { ReactNode } from "react";

export function ComparisonTable({ caption, headings, rows }: {
  caption: string;
  headings: string[];
  rows: ReactNode[][];
}) {
  return (
    <div className="blog-table-wrap">
      <table className="blog-comparison-table">
        <caption>{caption}</caption>
        <thead>
          <tr>{headings.map((heading) => <th key={heading} scope="col">{heading}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={`${caption}-${rowIndex}`}>
              {row.map((cell, cellIndex) => cellIndex === 0
                ? <th key={cellIndex} scope="row">{cell}</th>
                : <td key={cellIndex}>{cell}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ArticleCallout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <aside className="blog-callout">
      <strong>{title}</strong>
      <div>{children}</div>
    </aside>
  );
}

export function ArticleChecklist({ children }: { children: ReactNode }) {
  return <ul className="blog-checklist">{children}</ul>;
}
